import { guards } from './typeguards.helpers';

/** Admin UI path that throws a client error and calls the matching API. */
export const SENTRY_TEST_ADMIN_PATH = '/admin/sentry-test';

/** Query/search param that selects the test error text. */
export const SENTRY_TEST_MESSAGE_PARAM = 'message';

/** Max length of the user-supplied test text, applied on client and server. */
export const SENTRY_TEST_MESSAGE_MAX_LENGTH = 200;

const SENTRY_TEST_ERROR_PREFIX = 'Sentry test error';

/**
 * Picks the first non-empty string from a URL/query value.
 * Arrays use the first string entry (Express may parse repeated query keys as arrays).
 */
const firstNonEmptyString = (value: unknown): string | undefined => {
  if (guards.is.string(value)) {
    const trimmed = value.trim();
    return trimmed === '' ? undefined : trimmed;
  }
  if (guards.is.array(value)) return firstNonEmptyString(value[0]);
  return undefined;
};

/**
 * Error message thrown by the admin Sentry test page and API for a given
 * URL/query value. Returns undefined when the value is missing, blank, or not a string.
 * Client and server must use this so both exceptions share the same message.
 */
export const getSentryTestErrorMessage = (
  rawMessage: unknown,
): string | undefined => {
  const text = firstNonEmptyString(rawMessage);
  if (!text) return undefined;
  const clipped = text.slice(0, SENTRY_TEST_MESSAGE_MAX_LENGTH);
  return `${SENTRY_TEST_ERROR_PREFIX}: ${clipped}`;
};
